export default __webpack_public_path__ + "static/media/offer-6.92e3c696.jpg";